import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cream%20and%20sand%20abstract%20composition%20with%20flowing%20organic%20curves%2C%20soft%20terracotta%20and%20beige%20layered%20shapes%2C%20elegant%20minimalist%20geometric%20forms%2C%20gentle%20gradient%20blending%2C%20calm%20sophisticated%20atmosphere%2C%20modern%20editorial%20background%20with%20subtle%20texture%2C%20no%20text%20no%20people%2C%20artistic%20wallpaper%20style%20with%20warm%20earthy%20tones%20and%20delicate%20light%20play&width=1800&height=1000&seq=hero-bg-home-v2&orientation=landscape&nocache=true"
          alt="Sugargoo Spreadsheet resource hub background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-star-line text-sm text-primary-300"></i>
          </div>
          <span className="text-xs font-medium text-background-50/90 tracking-wide uppercase">
            Updated August 2026
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          The Ultimate
          <span className="block text-primary-300">Sugargoo Spreadsheet</span>
          Resource
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover curated product collections, expert shopping guides, verified reviews, shipping cost breakdowns, and exclusive discount codes — everything you need to shop smarter through Sugargoo Spreadsheet.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Sugargoo Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line"></i>
            </div>
          </a>
          <Link
            to="/article/what-is-sugargoo-spreadsheet"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Read Full Guide
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-article-line"></i>
            </div>
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-12">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
            </div>
            <span className="text-xs text-background-50/70">Updated Product Resources</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
            </div>
            <span className="text-xs text-background-50/70">Shopping Research Database</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
            </div>
            <span className="text-xs text-background-50/70">Shipping Cost Guides</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
            </div>
            <span className="text-xs text-background-50/70">Verified Safety Information</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <a href="#categories" className="flex flex-col items-center gap-2 text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">
          <span className="text-xs font-medium">Explore Categories</span>
          <div className="w-5 h-5 flex items-center justify-center animate-bounce">
            <i className="ri-arrow-down-s-line"></i>
          </div>
        </a>
      </div>
    </section>
  );
}